// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bootstrap Card Rounded Corners */
:host ::ng-deep .card {
  border-radius: 12px !important;
  overflow: hidden;
}

:host ::ng-deep .card-header {
  border-top-left-radius: 12px !important;
  border-top-right-radius: 12px !important;
}

/* ── Inline skeleton helpers (candidates & recent assessments sections) ── */
.skl-table-wrap {
  padding: 0;
}

.skl-table-head-row {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #dee2e6;
  background: #f8f9fa;
  min-height: 65px;
}

.skl-table-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
  align-items: start;
  padding: 10px 16px;
  border-bottom: 1px solid #f0f0f0;
  min-height: 60px;
}

.skl-donut-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.skl-donut-stats {
  min-width: 85px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skl-stat-row {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.skl-donut-circle-wrap {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.skl-donut-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: #e9ecef;
  position: relative;
  flex-shrink: 0;
}

.skl-donut-circle::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 66px;
  height: 66px;
  border-radius: 50%;
  background: #f8f9fa;
}

.skl-donut-legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: auto;
}

.skl-legend-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.skl-legend-dot {
  display: inline-block;
  width: 11px;
  height: 11px;
  border-radius: 2px;
  background: #e9ecef;
  flex-shrink: 0;
}

/* White shimmer inside blue card headers */
.candidates-card-header .skl-header-bar ::ng-deep .skeleton-block {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.25) 25%,
    rgba(255, 255, 255, 0.45) 50%,
    rgba(255, 255, 255, 0.25) 75%
  ) !important;
  background-size: 200% 100% !important;
}

@media (max-width: 1199.98px) {
  .skl-donut-circle-wrap {
    flex: 0 0 auto;
  }

  .skl-donut-circle {
    width: 100px;
    height: 100px;
  }

  .skl-donut-circle::after {
    width: 56px;
    height: 56px;
  }
}

@media (max-width: 767.98px) {
  .skl-donut-circle {
    width: 80px;
    height: 80px;
  }

  .skl-donut-circle::after {
    width: 44px;
    height: 44px;
  }
}


:host ::ng-deep .card-footer {
  border-bottom-left-radius: 12px !important;
  border-bottom-right-radius: 12px !important;
}

/* Strategy Boxes — equal-width grid */
.strategy-boxes-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

/* Strategy Box Card — icon in top right, text on left */
.strategy-box-card {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 18px 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
}

.strategy-box-card:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  border-color: #c0c0c0;
}

.strategy-box-card__content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}

.strategy-box-card__label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #888888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.2;
}

.strategy-box-card__value {
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1;
}

.strategy-box-card__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.strategy-box-card__icon mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

/* Strategy Box — compact flat boxes for readiness scores */
.strategy-box {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 20px 25px;
  border: 1px solid #e9ecef;
  border-left: 3px solid;
  border-radius: 6px;
  background: #f8f9fa;
  white-space: nowrap;
  overflow: hidden;
}

.strategy-box:hover {
  background: #e9ecef;
  transition: background-color 0.15s ease;
}

.strategy-box__label {
  font-size: 1.2rem;
  color: #495057;
}

.strategy-box__count {
  font-size: 1.2rem;
  font-weight: 700;
}

/* Chevron Text Colors */
.chevron-text-blue {
  color: #0066B2;
}

/* Dashboard Utility Classes */
.dashboard-cursor-pointer {
  cursor: pointer;
}

.dashboard-icon-18 {
  font-size: 18px;
  position: relative;
  top: 3px;
}

.dashboard-progress-lg {
  height: 40px;
}

.dashboard-table-scroll {
  overflow-y: visible;
}

/* Candidates Grid — shared table cell */
.candidates-td {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  font-size: 0.9rem;
  vertical-align: top;
  height: 60px;
}

.recent-code-assessments-header {
  height: 65px;
}

.top-candidates-header {
  height: 65px;
}

/* Truncate text to 2 lines with ellipsis */
.truncate-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  line-height: 1.4;
}

.assessment-status {
  white-space: nowrap;
}

/* Candidates Grid — card title */
.candidates-card-title {
  font-weight: 600;
  color: #fff;
}

/* Candidates Grid — blue card header */
.candidates-card-header {
  background: #0066B2 !important;
  border-bottom: none !important;
}

.conflict-card-subtitle {
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.75rem;
}

.conflict-count-badge {
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 999px;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 4px 10px;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.conflict-count-badge:hover,
.conflict-count-badge:focus-visible {
  background: rgba(255, 255, 255, 0.3);
  outline: 2px solid rgba(255, 255, 255, 0.8);
  outline-offset: 2px;
}

.cmdb-outcome-badge {
  background: #e7f1fa;
  border-radius: 999px;
  color: #005a9e;
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 4px 9px;
  white-space: nowrap;
}

/* Strategy Box Color Modifiers */
.strategy-box--primary {
  --box-color: #0066B2;
}

[class*="strategy-box--"] {
  border-left-color: var(--box-color);
}

[class*="strategy-box--"] .strategy-box__count {
  color: var(--box-color);
}

/* Readiness Donut Footer */
.readiness-donut-footer {
  display: flex;
  align-items: center;
  gap: 12px;
}

.readiness-stats {
  min-width: 85px;
}

.readiness-count-row {
  display: flex;
  align-items: baseline;
  gap: 5px;
  margin-top: 4px;
}

.readiness-count {
  font-size: 1rem;
  font-weight: 700;
}

.readiness-count-label {
  font-size: 0.78rem;
  color: #6c757d;
}

.readiness-donut-wrap {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.readiness-donut-svg {
  width: 120px;
  height: 120px;
}

/* On screens where readiness cards are full-width (< xl), collapse donut wrap to natural size */
@media (max-width: 1199.98px) {
  .readiness-donut-wrap {
    flex: 0 0 auto;
  }

  .readiness-donut-svg {
    width: 100px;
    height: 100px;
  }
}

@media (max-width: 767.98px) {
  .readiness-donut-svg {
    width: 80px;
    height: 80px;
  }
}

@media (max-width: 575.98px) {
  .readiness-donut-svg {
    width: 64px;
    height: 64px;
  }
}

.donut-center-count {
  font-size: 16px;
  font-weight: 700;
  fill: #212529;
}

.donut-center-label {
  font-size: 10px;
  fill: #6c757d;
}

.readiness-legend {
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-left: auto;
}

.readiness-legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
}

.readiness-legend-dot {
  display: inline-block;
  width: 11px;
  height: 11px;
  border-radius: 2px;
  flex-shrink: 0;
}

.readiness-legend-name {
  color: #6c757d;
  min-width: 48px;
}

.readiness-legend-pct {
  font-weight: 600;
  color: #212529;
}

.distribution-title {
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0.5px;
}

.clickable-text {
  text-decoration: underline;
  cursor: pointer;
}

.dashboard-error-container {
  min-height: 60vh;
}
`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/dashboard/dashboard.component.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA,6EAA6E;AAC7E;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE;;;;;cAKY;EACZ,qCAAqC;AACvC;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;;AAGA;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA,wDAAwD;AACxD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,uCAAuC;AACzC;;AAEA;;EAEE,oCAAoC;EACpC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,gGAAgG;AAChG;EACE;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Bootstrap Card Rounded Corners */\n:host ::ng-deep .card {\n  border-radius: 12px !important;\n  overflow: hidden;\n}\n\n:host ::ng-deep .card-header {\n  border-top-left-radius: 12px !important;\n  border-top-right-radius: 12px !important;\n}\n\n/* ── Inline skeleton helpers (candidates & recent assessments sections) ── */\n.skl-table-wrap {\n  padding: 0;\n}\n\n.skl-table-head-row {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid #dee2e6;\n  background: #f8f9fa;\n  min-height: 65px;\n}\n\n.skl-table-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 8px;\n  align-items: start;\n  padding: 10px 16px;\n  border-bottom: 1px solid #f0f0f0;\n  min-height: 60px;\n}\n\n.skl-donut-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.skl-donut-stats {\n  min-width: 85px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.skl-stat-row {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n}\n\n.skl-donut-circle-wrap {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.skl-donut-circle {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  background: #e9ecef;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.skl-donut-circle::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 66px;\n  height: 66px;\n  border-radius: 50%;\n  background: #f8f9fa;\n}\n\n.skl-donut-legend {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.skl-legend-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.skl-legend-dot {\n  display: inline-block;\n  width: 11px;\n  height: 11px;\n  border-radius: 2px;\n  background: #e9ecef;\n  flex-shrink: 0;\n}\n\n/* White shimmer inside blue card headers */\n.candidates-card-header .skl-header-bar ::ng-deep .skeleton-block {\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.25) 25%,\n    rgba(255, 255, 255, 0.45) 50%,\n    rgba(255, 255, 255, 0.25) 75%\n  ) !important;\n  background-size: 200% 100% !important;\n}\n\n@media (max-width: 1199.98px) {\n  .skl-donut-circle-wrap {\n    flex: 0 0 auto;\n  }\n\n  .skl-donut-circle {\n    width: 100px;\n    height: 100px;\n  }\n\n  .skl-donut-circle::after {\n    width: 56px;\n    height: 56px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .skl-donut-circle {\n    width: 80px;\n    height: 80px;\n  }\n\n  .skl-donut-circle::after {\n    width: 44px;\n    height: 44px;\n  }\n}\n\n\n:host ::ng-deep .card-footer {\n  border-bottom-left-radius: 12px !important;\n  border-bottom-right-radius: 12px !important;\n}\n\n/* Strategy Boxes — equal-width grid */\n.strategy-boxes-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n/* Strategy Box Card — icon in top right, text on left */\n.strategy-box-card {\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 18px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  position: relative;\n}\n\n.strategy-box-card:hover {\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  border-color: #c0c0c0;\n}\n\n.strategy-box-card__content {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n}\n\n.strategy-box-card__label {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #888888;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  line-height: 1.2;\n}\n\n.strategy-box-card__value {\n  font-size: 1.75rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.strategy-box-card__icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.strategy-box-card__icon mat-icon {\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n}\n\n/* Strategy Box — compact flat boxes for readiness scores */\n.strategy-box {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 20px 25px;\n  border: 1px solid #e9ecef;\n  border-left: 3px solid;\n  border-radius: 6px;\n  background: #f8f9fa;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.strategy-box:hover {\n  background: #e9ecef;\n  transition: background-color 0.15s ease;\n}\n\n.strategy-box__label {\n  font-size: 1.2rem;\n  color: #495057;\n}\n\n.strategy-box__count {\n  font-size: 1.2rem;\n  font-weight: 700;\n}\n\n/* Chevron Text Colors */\n.chevron-text-blue {\n  color: #0066B2;\n}\n\n/* Dashboard Utility Classes */\n.dashboard-cursor-pointer {\n  cursor: pointer;\n}\n\n.dashboard-icon-18 {\n  font-size: 18px;\n  position: relative;\n  top: 3px;\n}\n\n.dashboard-progress-lg {\n  height: 40px;\n}\n\n.dashboard-table-scroll {\n  overflow-y: visible;\n}\n\n/* Candidates Grid — shared table cell */\n.candidates-td {\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n  font-size: 0.9rem;\n  vertical-align: top;\n  height: 60px;\n}\n\n.recent-code-assessments-header {\n  height: 65px;\n}\n\n.top-candidates-header {\n  height: 65px;\n}\n\n/* Truncate text to 2 lines with ellipsis */\n.truncate-text {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-break: break-word;\n  line-height: 1.4;\n}\n\n.assessment-status {\n  white-space: nowrap;\n}\n\n/* Candidates Grid — card title */\n.candidates-card-title {\n  font-weight: 600;\n  color: #fff;\n}\n\n/* Candidates Grid — blue card header */\n.candidates-card-header {\n  background: #0066B2 !important;\n  border-bottom: none !important;\n}\n\n.conflict-card-subtitle {\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 0.75rem;\n}\n\n.conflict-count-badge {\n  background: rgba(255, 255, 255, 0.18);\n  border: 1px solid rgba(255, 255, 255, 0.45);\n  border-radius: 999px;\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 4px 10px;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.conflict-count-badge:hover,\n.conflict-count-badge:focus-visible {\n  background: rgba(255, 255, 255, 0.3);\n  outline: 2px solid rgba(255, 255, 255, 0.8);\n  outline-offset: 2px;\n}\n\n.cmdb-outcome-badge {\n  background: #e7f1fa;\n  border-radius: 999px;\n  color: #005a9e;\n  display: inline-block;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 4px 9px;\n  white-space: nowrap;\n}\n\n/* Strategy Box Color Modifiers */\n.strategy-box--primary {\n  --box-color: #0066B2;\n}\n\n[class*=\"strategy-box--\"] {\n  border-left-color: var(--box-color);\n}\n\n[class*=\"strategy-box--\"] .strategy-box__count {\n  color: var(--box-color);\n}\n\n/* Readiness Donut Footer */\n.readiness-donut-footer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.readiness-stats {\n  min-width: 85px;\n}\n\n.readiness-count-row {\n  display: flex;\n  align-items: baseline;\n  gap: 5px;\n  margin-top: 4px;\n}\n\n.readiness-count {\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.readiness-count-label {\n  font-size: 0.78rem;\n  color: #6c757d;\n}\n\n.readiness-donut-wrap {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.readiness-donut-svg {\n  width: 120px;\n  height: 120px;\n}\n\n/* On screens where readiness cards are full-width (< xl), collapse donut wrap to natural size */\n@media (max-width: 1199.98px) {\n  .readiness-donut-wrap {\n    flex: 0 0 auto;\n  }\n\n  .readiness-donut-svg {\n    width: 100px;\n    height: 100px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .readiness-donut-svg {\n    width: 80px;\n    height: 80px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .readiness-donut-svg {\n    width: 64px;\n    height: 64px;\n  }\n}\n\n.donut-center-count {\n  font-size: 16px;\n  font-weight: 700;\n  fill: #212529;\n}\n\n.donut-center-label {\n  font-size: 10px;\n  fill: #6c757d;\n}\n\n.readiness-legend {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  margin-left: auto;\n}\n\n.readiness-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.78rem;\n}\n\n.readiness-legend-dot {\n  display: inline-block;\n  width: 11px;\n  height: 11px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n\n.readiness-legend-name {\n  color: #6c757d;\n  min-width: 48px;\n}\n\n.readiness-legend-pct {\n  font-weight: 600;\n  color: #212529;\n}\n\n.distribution-title {\n  font-weight: bold;\n  font-size: 14px;\n  letter-spacing: 0.5px;\n}\n\n.clickable-text {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.dashboard-error-container {\n  min-height: 60vh;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
